import { FC, useMemo } from 'react';
import classNames from 'classnames';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import { AdvertPhotoType } from '@edikk-edikk/country-common';
import { AdvertPictureForPhoto } from '@edikk-edikk/country-layout-black';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import galleryThumbnailCss from '../../../assets/gallery/gallery-thumbnail.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  photo: AdvertPhotoType;
  index: number;
  isActive: boolean;
};

const Thumbnail: FC<PropsType> = ({
  photo,
  index,
  isActive,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();
  const withBlur = useMemo(() => !isBot && isDeleted, [isBot, isDeleted]);

  return (
    <div
      className={classNames(
        swiperCss.swiper__slide,
        galleryThumbnailCss.galleryThumbnail,
        { [galleryThumbnailCss.galleryThumbnail_active]: isActive },
      )}
    >
      <AdvertPictureForPhoto
        photo={photo}
        className={classNames(
          galleryThumbnailCss.galleryThumbnail__image,
          { [galleryThumbnailCss.galleryThumbnail__image_withBlur]: withBlur },
        )}
        alt={`Preview for photo ${index + 1}`}
        isUse100
      />
    </div>
  );
};

export { Thumbnail };
